import $axiosProtected from "../../common/utils/axiosUtils";

// Get patient assigned focused groups
export const getPatientAssignedFocusedGroup = async (payload: any) => {
  return await $axiosProtected().post(
    `vitals/web-portal/patient/focusedgroup-list/get`,
    payload
  );
};
